
import { useEffect } from 'react';
import { KpiCardType } from '../types';

// This hook is used for automated testing and debugging
export const useQaTesting = (
  kpiCards: KpiCardType[], 
  setKpiCards: React.Dispatch<React.SetStateAction<KpiCardType[]>>
) => {
  // Only run in development mode if a specific query param is present
  useEffect(() => {
    // Check if we're in test mode
    const urlParams = new URLSearchParams(window.location.search);
    const autoTest = urlParams.get('autoTest');
    
    if (autoTest !== 'dashboard') return;
    
    // If testing is enabled, log the current state of kpiCards
    console.log('Dashboard QA Testing Mode: Current KPI Cards', kpiCards);
  }, [kpiCards]);
};
